import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import InterstitialContentViewport from './InterstitialContentViewport';
import { BaseContentControlWrapper } from '../ContentControlWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BasicInterstitial = ({
  buttonLink,
  buttonI18n,
  buttonUse = 'primary',
  illustrationName,
  headingI18n,
  onButtonClick = () => {},
  subheadingI18n,
  testId = 'interstitial',
  use = 'info'
}) => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": testId,
    children: [/*#__PURE__*/_jsx(InterstitialContentViewport, {
      use: use,
      viewportStyles: {
        padding: '50px',
        textAlign: 'center'
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        minBlockSize: "350px",
        children: [illustrationName && /*#__PURE__*/_jsx(Illustration, {
          alt: I18n.text('learningCenter.tracks.interstitials.illustration'),
          name: illustrationName,
          width: "110"
        }), /*#__PURE__*/_jsx(Text, {
          as: "h4",
          color: use === 'success' ? 'text-core-on-fill-default' : undefined,
          marginBlockStart: "700",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: headingI18n
          })
        }), /*#__PURE__*/_jsx(Text, {
          color: use === 'success' ? 'text-core-on-fill-default' : undefined,
          marginBlockStart: "500",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: subheadingI18n
          })
        })]
      })
    }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      children: buttonLink ? /*#__PURE__*/_jsx(RouterButton, {
        onClick: onButtonClick,
        to: buttonLink,
        use: buttonUse,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: buttonI18n
        })
      }) : /*#__PURE__*/_jsx(Button, {
        onClick: onButtonClick,
        use: buttonUse,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: buttonI18n
        })
      })
    })]
  });
};
export default BasicInterstitial;